export const CONTROL_PERMISSIONS = {
  controlRead: 'control:read',
  licensesRead: 'licenses:read',
  licensesWrite: 'licenses:write',
  grantsWrite: 'grants:write',
  analyticsRead: 'analytics:read',
  auditRead: 'audit:read',
  autoloadRead: 'autoload:read',
  autoloadWrite: 'autoload:write',
} as const;

export type ControlPermission = typeof CONTROL_PERMISSIONS[keyof typeof CONTROL_PERMISSIONS];
